import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Die Startseite und alle Landing-Seiten (Immobilien, FAQ, Über uns, Impressum, Widerruf) liefert
    // die Astro-Landingpage (landing/). Nginx gibt Angular nur noch für /home/booking*, /user und /admin aus.
    // Landet trotzdem eine unbekannte URL in der App, geht es zur Buchung.
    { path: '', pathMatch: 'full', redirectTo: 'home/booking' },
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'home',
                loadChildren: () =>
                    import('app/modules/landing/home/home.module').then(
                        (m) => m.LandingHomeModule,
                    ),
            },
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        data: {
            roles: ['app-admin', 'app-user'],
            layout: 'empty',
        },
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'admin',
                loadChildren: () =>
                    import('app/modules/admin/admin.module').then(
                        (m) => m.AdminModule,
                    ),
            },
        ],
    },

    //User routes
    {
        path: '',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        data: {
            roles: ['app-user'],
            layout: 'empty',
        },
        children: [
            {
                path: 'user',
                loadChildren: () =>
                    import('app/modules/user/user.module').then(
                        (m) => m.UserModule,
                    ),
            },
        ],
    },
    { path: '**', redirectTo: 'home/booking' },
];
